import { ContactLeadReadable } from '@crm/api'
import { Text } from '@crm/components'
import { Badge, Dropdown, Tag } from 'antd'
import { BadgeProps } from 'antd/lib'
import { useTheme } from 'antd-style'
import { useTranslation } from 'react-i18next'

type Props = {
  leads?: ContactLeadReadable[]
} & BadgeProps

const getLeadName = (lead: ContactLeadReadable) => lead.name || '-'

export const Leads = ({ leads, ...props }: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const [primaryLead, ...extraLeads] = leads ?? []

  if (!primaryLead) return '-'

  const badge = (
    <Badge
      {...props}
      color={theme.colorPrimary}
      count={extraLeads.length ? `+${extraLeads.length}` : null}
    >
      <Tag>
        <Text>{getLeadName(primaryLead)}</Text>
      </Tag>
    </Badge>
  )

  if (!extraLeads.length) return badge

  return (
    <Dropdown
      menu={{
        onClick: (e) => e.domEvent.stopPropagation(),
        items: [
          { key: 'title', label: <Text>{t('lead.leads')}</Text> },
          ...extraLeads.map((lead) => ({
            key: lead.id,
            label: <Text>{getLeadName(lead)}</Text>
          }))
        ]
      }}
      trigger={['hover']}
    >
      {badge}
    </Dropdown>
  )
}
